import { HSFormStateItem, HSFormValues, NoteState, RootState } from '../../../';
import { createSelector } from '@reduxjs/toolkit';
import { selectIsMarkdownSupportEnabled } from './../provider/selectors.ts';

export const isObject = (value: any) => typeof value === 'object' && value !== null;

export const selectNoteState = (state: RootState): NoteState => state.note;

export const selectHSFormState = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.hsForm;
};

export const selectReevalSentences = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.progressSentences.items;
}

export const selectReevalModalHasError = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.progressSentences.hasError;
}

export const selectIsReevalSentenceLoading = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.progressSentences.items.some((sentence) => sentence.isLoading);
}

export const selectIsAddingNewSentence = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.progressSentences.isAddingNewSentence
}

export const selectAddNewModalOpen = (state: RootState) => {
  const noteState = selectNoteState(state);
  return noteState.progressSentences.addNewModalOpen;
}

export const selectIsHSFormValid = (state: RootState) => {
  const hsForm = selectHSFormState(state);
  return hsForm && Object.values(hsForm).every((v: HSFormStateItem) => !v.error);
};

export const selectHSFormValues = createSelector([selectHSFormState], (hsForm) => {
  return Object.entries(hsForm)
    .filter(([_, value]) => isObject(value))
    .reduce((formValues, [key, v]) => {
      return {
        ...formValues,
        [key]: v.value,
      };
    }, {} as HSFormValues);
});

export const selectHSFormShowRequiredFieldsDialog = (state: RootState): boolean => {
  const hsForm = selectHSFormState(state);
  return hsForm.showRequiredFieldsDialog || false;
};

export const selectNoteMarkdownContent = (state: RootState) => state.note.noteMarkdownContent;

export const selectNoteTemplates = (state: RootState) => state.note.templates;

export const selectNoteSections = (state: RootState) => state.note.noteSections;

export const selectIsMDMEnabled = (state: RootState) => state.note.noteSections.includes('MDM');

export const selectNoteTemplateIdSelected = (state: RootState) =>
  state?.note?.noteTemplateSelectedId;

export const isSingleSectionNote = (state: RootState) =>
  (selectIsMarkdownSupportEnabled(state) &&
    (!state.note.noteSections || state.note.noteSections?.length === 0)) ||
  (selectIsMarkdownSupportEnabled(state) &&
    state.note.noteSections.find((section: string) => section === 'WHOLE_NOTE'));

export const selectIsNewNote = (state: RootState) =>
  selectIsMarkdownSupportEnabled(state) &&
  (!state.note.noteSections || state.note.noteSections?.length === 0);
